/**
 * Törzsadat-legördülő: EZ a mező kell mindenhová, ahol egy lista egy elemét
 * választja ki a felhasználó (nyelv, ország, orvos, rendelő, szolgáltatás…).
 *
 * Annyival több a `searchable-select`-nél, hogy nem a hívóra bízza a döntést,
 * hanem hozza magával a szabályt: ésszerű elemszám fölött kereső, alatta natív
 * legördülő (utils/lookup-options.js), és kérésre a magyar sort a lista élére
 * emeli. A hívónak így nincs se küszöbje, se rendezése — csak a listája.
 *
 * A `searchable-select` marad a nyers, MINDIG kereső mező. Azt kell használni
 * ott, ahol a lista szerverről szűkül (`@search`), mert ott a natív legördülőre
 * visszaesés menet közben elvenné a beviteli mezőt a felhasználó alól.
 */
import SearchableSelect from './searchable-select.vue';
import { SEARCHABLE_OPTION_THRESHOLD, hungarianFirst as hoistHungarian } from '@/utils/lookup-options';
export default {
  name: 'LookupSelect',
  components: {
    SearchableSelect
  },
  // Minden más (v-model, placeholder, invalid, disabled, size, label-field,
  // translation-field, name, group-field, class, style) érintetlenül megy át.
  inheritAttrs: false,
  props: {
    options: {
      type: Array,
      default: function () {
        return [];
      }
    },
    // Nyelv, állampolgárság, ország: a magyar sor a lista élére kerül.
    hungarianFirst: {
      type: Boolean,
      default: false
    },
    // A listát a MEGJELENÍTETT felirat szerint rendezi, a felület nyelvének
    // ábécérendjével. Azoknak a törzsadatoknak kell, amiket a szerver ISO-kód
    // sorrendben ad vissza (nyelv, ország): kód szerint az „Aruba" megelőzi az
    // „Albániát", ami majdnem ábécérendnek látszik, és épp ezért félrevezet.
    sortByLabel: {
      type: Boolean,
      default: false
    },
    // Csak akkor add meg, ha egy képernyőnek indokoltan más a küszöbe.
    threshold: {
      type: Number,
      default: SEARCHABLE_OPTION_THRESHOLD
    },
    // Ugyanaz a jelentés, mint a searchable-select-en; azért deklarált prop, mert a
    // rendezésnek is tudnia kell, honnan jön a felirat, nem csak a mezőnek.
    labelField: {
      type: String,
      default: 'name'
    },
    translationField: {
      type: String,
      default: 'translation_key'
    }
  },
  computed: {
    // Nem a betöltött listát rendezzük át, hanem a megjelenítést: a nyers
    // lista így ugyanaz marad minden más fogyasztójának.
    sortedOptions: function () {
      const options = this.sortByLabel ? this.alphabetical : this.options;
      return this.hungarianFirst ? hoistHungarian(options) : options;
    },
    alphabetical: function () {
      const collator = new Intl.Collator(this.$i18n?.locale || 'hu', {
        sensitivity: 'base'
      });
      return [...(this.options || [])].sort((a, b) => collator.compare(this.labelOf(a), this.labelOf(b)));
    }
  },
  methods: {
    // Ugyanaz a felirat, amit a mező kiír — a fordítási kulcson át, ha van.
    labelOf: function (option) {
      const key = option?.[this.translationField];
      const label = key ? this.$t(key) : option?.[this.labelField];
      return String(label ?? '');
    }
  }
};